import {MatTableDataSource} from '@angular/material';
import {VerityPriceModel} from '../../models/verity-price-model';
import {Subject} from 'rxjs';

export class VerityTableDataSource extends MatTableDataSource<VerityPriceModel> {

  filterUpdate: Subject<any> = new Subject();
  sortUpdate: Subject<Array<VerityPriceModel>> = new Subject();
  sortedData = [];

  filter: any;

  constructor(initialData?: Array<any>) {
    super(initialData);
    this.filterPredicate = function (data, filter): boolean {
      const keys = Object.keys(filter);

      for (const key of keys) {
        if (filter[key].indexOf(data[key]) === -1) {
          return false;
        }
      }

      return true;
    };
  }

  _filterData(data: VerityPriceModel[]): VerityPriceModel[] {
    let result = [];

    if (data.length > 0) {
      try {
        result = super._filterData(data);
        this.filterUpdate.next(result);
      } catch (e) {
        console.log(e);
      }
    }

    return result;
  }

  _orderData(data: VerityPriceModel[]): VerityPriceModel[] {
    if (this.data.length > 0) {
      this.sortedData = super._orderData(data);
      this.sortUpdate.next(this.sortedData);

      return this.sortedData;
    }

    return this.sortedData;
  }
}
